// https://github.com/blakeembrey/change-case/blob/main/packages/title-case/src/index.ts
const SMALL_WORDS = new Set([
  "a",
  "an",
  "and",
  "as",
  "at",
  "because",
  "but",
  "by",
  "en",
  "for",
  "if",
  "in",
  "neither",
  "nor",
  "of",
  "on",
  "only",
  "or",
  "over",
  "per",
  "so",
  "some",
  "than",
  "that",
  "the",
  "to",
  "up",
  "upon",
  "v",
  "versus",
  "via",
  "vs",
  "when",
  "with",
  "without",
  "yet",
]);

export function toTitleCase(str: string): string {
  let isFirstWord = true;

  return str.toLowerCase().replace(/\S+/g, (word) => {
    // Always capitalize the first word
    if (isFirstWord) {
      isFirstWord = false;
      return word.charAt(0).toUpperCase() + word.slice(1);
    }

    // Keep small words lowercase
    if (SMALL_WORDS.has(word)) {
      return word;
    }

    // Capitalize other words
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
}
